import { GET_GIS_FILES_QUERY } from '../operations';
import { useQuery } from '@apollo/client';

export const useGetGisFiles = () => {
  const { data, loading, error, refetch } = useQuery(GET_GIS_FILES_QUERY);


  return {
    files: data?.gisFiles?.files,
    loading,
    error,
    refetch,
  };
};
